import { formatISODate } from '@/utils/date';
import type { EfaxPatient } from '../../types';
import { getPatientDisplayName } from '../../utils/efax-item-helpers';
import { hasExtractedValue, splitOverflowValues } from './efax-cell-utils';
import { MissingValue } from './MissingValue';
import { OverflowListCell } from './OverflowListCell';

interface PatientCellProps {
  patient: EfaxPatient | null;
}

export const PatientCell = ({ patient }: PatientCellProps) => {
  const name = getPatientDisplayName(patient);

  if (!hasExtractedValue(name)) {
    return <MissingValue />;
  }

  const dateOfBirth = patient?.dateOfBirth;
  const formattedDob = hasExtractedValue(dateOfBirth)
    ? formatISODate(dateOfBirth as string)
    : '—';

  return (
    <div>
      <div className="font-medium">
        <OverflowListCell values={splitOverflowValues(name)} />
      </div>
      <div className="text-muted-foreground text-xs">DOB {formattedDob}</div>
    </div>
  );
};
